function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("linearGradient", {
  id: "a",
  x1: "100%",
  y1: "103.757%",
  y2: "0%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#181A2F",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#F90"
})), React.createElement("linearGradient", {
  id: "d",
  x1: "-8.699%",
  x2: "98.109%",
  y1: "68.169%",
  y2: "35.795%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#1A1A2C"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#FF9800"
})), React.createElement("path", {
  id: "c",
  d: "M3.69 232.521c1.36-27.506 9.267-42.961 23.718-46.365 21.677-5.104 62.67-10.572 86.578-29.56 23.906-18.986 23.15-33.063 59.518-37.428 36.368-4.366 46.036-22.99 90.021-37.417C307.51 67.324 322.615 70.185 351 45.542c18.924-16.428 42.757-29.864 71.5-40.307"
}), React.createElement("filter", {
  id: "b",
  width: "107.5%",
  height: "113.9%",
  x: "-3.7%",
  y: "-5.2%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 1.5,
  result: "shadowSpreadOuter1"
}), React.createElement("feOffset", {
  dy: 4,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 1.5,
  result: "shadowInner"
}), React.createElement("feOffset", {
  dy: 4,
  in: "shadowInner",
  result: "shadowInner"
}), React.createElement("feComposite", {
  in: "shadowOffsetOuter1",
  in2: "shadowInner",
  operator: "out",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 4
}), React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
})), React.createElement("circle", {
  id: "f",
  cx: 5,
  cy: 185,
  r: 5
}), React.createElement("filter", {
  id: "e",
  width: "240%",
  height: "240%",
  x: "-70%",
  y: "-50%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
})), React.createElement("circle", {
  id: "h",
  cx: 99,
  cy: 148,
  r: 5
}), React.createElement("filter", {
  id: "g",
  width: "240%",
  height: "240%",
  x: "-70%",
  y: "-50%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
})), React.createElement("circle", {
  id: "j",
  cx: 201,
  cy: 98,
  r: 5
}), React.createElement("filter", {
  id: "i",
  width: "240%",
  height: "240%",
  x: "-70%",
  y: "-50%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
})), React.createElement("circle", {
  id: "l",
  cx: 298,
  cy: 63,
  r: 5
}), React.createElement("filter", {
  id: "k",
  width: "240%",
  height: "240%",
  x: "-70%",
  y: "-50%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
})), React.createElement("circle", {
  id: "n",
  cx: 397,
  cy: 5,
  r: 5
}), React.createElement("filter", {
  id: "m",
  width: "240%",
  height: "240%",
  x: "-70%",
  y: "-50%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "#FFF",
  fontFamily: "Roboto-Medium, Roboto",
  fontSize: 12,
  fontWeight: 400,
  letterSpacing: -0.006,
  opacity: 0.2
}, React.createElement("text", {
  transform: "translate(42.485 315.66)"
}, React.createElement("tspan", {
  x: 294.515,
  y: 11
}, "2018")), React.createElement("text", {
  transform: "translate(42.485 315.66)"
}, React.createElement("tspan", {
  x: 390.515,
  y: 11
}, "2019")), React.createElement("text", {
  transform: "translate(42.485 315.66)"
}, React.createElement("tspan", {
  x: 198.515,
  y: 11
}, "2017")), React.createElement("text", {
  transform: "translate(42.485 315.66)"
}, React.createElement("tspan", {
  x: 93.515,
  y: 11
}, "2016")), React.createElement("text", {
  transform: "translate(42.485 315.66)"
}, React.createElement("tspan", {
  x: 0.515,
  y: 11
}, "2015"))), React.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "square",
  d: "M26.416 300.25H446.5",
  opacity: 0.068
}), React.createElement("path", {
  fill: "url(#a)",
  d: "M3.212 232.791s0-46.157 30.911-48.781c30.911-2.625 66.882-16.515 85.455-32.98 18.572-16.467 26.977-31.822 54.25-31.822 27.274 0 68.379-37.087 123.65-47.901C352.75 60.492 342.5 41.729 379.3 25.96c15.147-6.49 22.078-18.547 44.7-20.726v227.556H3.212z",
  transform: "translate(24 67)"
}), React.createElement("g", {
  fillRule: "nonzero",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "translate(24 67)"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#b)",
  xlinkHref: "#c"
}), React.createElement("use", {
  stroke: "url(#d)",
  strokeWidth: 3,
  xlinkHref: "#c"
})), React.createElement("text", {
  fill: "#FFF",
  fontFamily: "Roboto-Medium, Roboto",
  fontSize: 11,
  fontWeight: 400,
  letterSpacing: 1,
  transform: "translate(24 67)"
}, React.createElement("tspan", {
  x: 4.879,
  y: 147
}, "7 320 54"), React.createElement("tspan", {
  x: 55.869,
  y: 147
}, "1")), React.createElement("text", {
  fill: "#FFF",
  fontFamily: "Roboto-Medium, Roboto",
  fontSize: 11,
  fontWeight: 400,
  letterSpacing: 1,
  transform: "translate(24 67)"
}, React.createElement("tspan", {
  x: 92.758,
  y: 112
}, "16 430 19"), React.createElement("tspan", {
  x: 150.995,
  y: 112
}, "6")), React.createElement("text", {
  fill: "#FFF",
  fontFamily: "Roboto-Medium, Roboto",
  fontSize: 11,
  fontWeight: 400,
  letterSpacing: 1,
  transform: "translate(24 67)"
}, React.createElement("tspan", {
  x: 189.883,
  y: 65
}, " 24 540 20"), React.createElement("tspan", {
  x: 251.865,
  y: 65
}, "0")), React.createElement("text", {
  fill: "#FFF",
  fontFamily: "Roboto-Medium, Roboto",
  fontSize: 11,
  fontWeight: 400,
  letterSpacing: 1,
  transform: "translate(24 67)"
}, React.createElement("tspan", {
  x: 288.389,
  y: 29
}, " 38 616 91"), React.createElement("tspan", {
  x: 350.359,
  y: 29
}, "4")), React.createElement("text", {
  fill: "#FFF",
  fontFamily: "Roboto-Medium, Roboto",
  fontSize: 11,
  fontWeight: 400,
  letterSpacing: 1
}, React.createElement("tspan", {
  x: 408.886,
  y: 45
}, " 42 456 400")), React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("g", {
  transform: "translate(50 67)"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#e)",
  xlinkHref: "#f"
}), React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#f"
})), React.createElement("g", {
  transform: "translate(50 67)"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#g)",
  xlinkHref: "#h"
}), React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#h"
})), React.createElement("g", {
  transform: "translate(50 67)"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#i)",
  xlinkHref: "#j"
}), React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#j"
})), React.createElement("g", {
  transform: "translate(50 67)"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#k)",
  xlinkHref: "#l"
}), React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#l"
})), React.createElement("g", {
  transform: "translate(50 67)"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#m)",
  xlinkHref: "#n"
}), React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#n"
}))), React.createElement("path", {
  d: "M0 0h497v344H0z"
}));

const SvgInfographics = props => React.createElement("svg", _extends({
  width: 498,
  height: 344,
  viewBox: "0 0 498 344"
}, props), _ref, _ref2);

export default __webpack_public_path__ + "static/media/infographics.c9e4a321.svg";
export { SvgInfographics as ReactComponent };